export function initializeKeyfiguresFilters(translate) {
  const initialFilters = [
    {
      id: "nogaCode",
      label: translate("benchmarking.evaluations.overheads.filters.noga"),
      items: [],
      ignoreSort: true,
      customTagLabel: (item) => `${item.id}`,
    },
    {
      id: "greaterRegion",
      label: translate("benchmarking.evaluations.overheads.filters.canton"),
      items: [],
      ignoreSort: true,
      customTagLabel: (item) => `${item.name}`,
    },
    {
      id: "officeSize",
      label: translate("benchmarking.evaluations.overheads.filters.officeSize"),
      items: [],
      ignoreSort: true,
      customTagLabel: (item) => `${item.name}`,
    },
  ];

  return {
    filters: initialFilters,
    newest: true,
    isInitialLoad: true,
    allAvailabeFilters: {},
  };
}
